import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { setSessionExpiredHandler, setTokenRefreshedHandler, setAccessToken, setRefreshToken } from './services/http'

Vue.config.productionTip = false

// Bootstrap in-memory tokens from the Vuex store rehydrated by VuexPersistence.
// Without this, _accessToken is always null after a page reload and every request
// has to fall back to parsing localStorage on each call.
var persistedUser = store.state.user
if (persistedUser) {
  if (persistedUser.accessToken) setAccessToken(persistedUser.accessToken)
  if (persistedUser.refreshToken) setRefreshToken(persistedUser.refreshToken)
  store.dispatch('uploadDrafts/REFRESH_SUMMARY')
}

// After a silent token refresh, write the new tokens back into Vuex so that
// VuexPersistence flushes them to localStorage. Without this, a rotated
// refresh token is lost on the next page reload and the session is broken.
setTokenRefreshedHandler(function (tokens) {
  store.commit('UPDATE_USER_TOKENS', tokens)
})

setSessionExpiredHandler(function () {
  store.dispatch('LOG_OUT')
  var route = router.currentRoute
  var requiresAuth = route && route.matched.some(function (r) { return r.meta.requiresAuth })
  if (requiresAuth) {
    router.push('/account')
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
